import { FormGroup } from '@angular/forms';
import { Store } from '@ngrx/store';
import { Revisione53State } from '../../../store/revisione53.reducers';
import { updateVerbaleOnStore } from '@core/helpers/create-validator.helper';
import { getControl } from '@shared/helpers/form.helper';
import { cloneDeep } from 'lodash-es';
import { CkNormeValues } from '../common/models/amm-controllo.type';
import { aggiornaSociSchedaAmmCtrl } from '../common/helpers/norme-store-update.helper';
import { withChangeDebounced } from '@shared/operators/with-change-debounced.operator';
import { toNum } from '@shared/helpers/math.helper';
import { withCkNormeGuard } from '../common/operators/with-ck-norme-guard.operator';
import { MyVerbale } from '../../../models/interfaces/revisione.interface';

const AMM_CTRL_PATH = 'my_SezioneI__Rilevazione.my_AmministrazioneControllo';

export const my_CkNormeListenerHelper = (form: FormGroup, store: Store<Revisione53State>, valoreNormaAttesa: CkNormeValues) => {
    const campiStampaMinistero = ['my_StampaMinistero_ChkSRL', 'my_StampaMinistero_ChkSPO', 'my_StampaMinistero_ChkSPD', 'my_StampaMinistero_ChkSPM'];
    const ckNormeControl = getControl(form, `${AMM_CTRL_PATH}.my_CkNorme`);

    return ckNormeControl.valueChanges.pipe(withChangeDebounced(ckNormeControl), withCkNormeGuard(form, valoreNormaAttesa)).subscribe(() => {
        const normaAttesa = toNum(valoreNormaAttesa);
        const valoriStampaMinistero = campiStampaMinistero.reduce((acc, nomeCampo, index) => {
            acc[nomeCampo] = index === normaAttesa - 1 ? '1' : '0';
            return acc;
        }, {} as Record<string, string>);

        Object.entries(valoriStampaMinistero).forEach(([nomeCampo, valore]) => {
            getControl(form, `my_GlobalFields.${nomeCampo}`).patchValue(valore, { emitEvent: false });
        });

        updateVerbaleOnStore(store, (myVerbale) => {
            const myVerbaleClone: MyVerbale = cloneDeep(myVerbale);
            Object.entries(valoriStampaMinistero).forEach(([nomeCampo, valore]) => {
                myVerbaleClone.my_GlobalFields[nomeCampo] = valore;
            });
            return myVerbaleClone;
        });

        aggiornaSociSchedaAmmCtrl(store);
    });
};
